import type { ListBuilderList } from '../../../types';
import { createStandardOrderClientEmbeddedColumns } from '../columns';
import { ORDER_CLIENT_EMBEDDED_REQUIRED_FIELDS } from '../shared';

/**
 * Client Embedded All Orders list configuration
 * Complete list of all orders (embedded in client view)
 */
export const clientEmbeddedOrdersAllList: ListBuilderList = {
	id: 'client-embedded-orders-all',
	cacheTTL: 600000,
	name: 'All Orders',
	type: 'default',
	active: true,
	sortOrder: 6,
	columns: createStandardOrderClientEmbeddedColumns(),
	description: 'Complete list of all orders',
	defaultSortId: 'column-dates-desc',
	requiredFields: ORDER_CLIENT_EMBEDDED_REQUIRED_FIELDS,
};
